import React from 'react';
import { v4 } from 'uuid';
import { UseOpenWorkspacePanelWorkspaceConfig } from '../../panels/use-open-workspace-panel';
import { useIntegratedActionBroadcaster } from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { CadNextAction } from '../../action-broadcaster/types';

export type OpenBoloPanelArgs = {
    boloId?: number;
    shouldFocus?: boolean;
    workspacePanelConfig?: Omit<UseOpenWorkspacePanelWorkspaceConfig<'BOLO'>, 'workspacePanelType'>;
};

export function useOpenBoloPanel(): (args: OpenBoloPanelArgs) => void {
    const { trigger } = useIntegratedActionBroadcaster();
    const enabledFeatures = useEnabledFeatures();
    return React.useCallback(
        (args: OpenBoloPanelArgs) => {
            const initialTab = args?.workspacePanelConfig?.panelState?.initialTab;
            if (enabledFeatures.createBolos) {
                trigger([
                    {
                        id: v4(),
                        targetWindowType: 'ROOT',
                        type: 'OPEN_EVENT_V2_WINDOW',
                    },
                    {
                        id: v4(),
                        targetWindowType: 'EVENT_V2',
                        type: 'OPEN_BOLO_PANEL',
                        payload: args,
                    },
                    ...(args.boloId !== undefined && initialTab
                        ? [
                              {
                                  id: v4(),
                                  targetWindowType: 'EVENT_V2',
                                  type: 'SET_BOLO_PANEL_TAB',
                                  payload: {
                                      boloId: args.boloId,
                                      tab: initialTab,
                                  },
                              } as CadNextAction,
                          ]
                        : []),
                ]);
            }
        },
        [trigger, enabledFeatures]
    );
}
